import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import {
  PrimaryButton,
  UploadButton,
} from "../../../../components/ui/Button";
import AddCoApplicantIcon from "../../../../assets/icons/plus.png";
import TriggerLinkIcon from "../../../../assets/images/icons/link.png";
import Eyecon from "../../../../assets/images/icons/eyeNew.png";
import UploadWhiteIcon from "../../../../assets/images/icons/uploadWhite.png";
import eligibilityCheckServices from "../../../../services/api/service/eligibilityCheckService";

type Props = {
  isXsOrSm: boolean;
  tabIndex: number;
  countBulkUpload: number;
  isAddingCoApplicant: boolean;
  enableCustomerJourney: boolean;
  partnerStartedJourney: boolean;
  showTitle?: boolean;
  showActions?: boolean;
  hideTriggerLink?: boolean;
  documentsReadOnly?: boolean;
  triggerOnly?: boolean;
  primaryTriggerLink?: boolean;
  onAddCoApplicant: () => void;
  onTriggerLinkToCustomer: () => void;
  onViewBulkDocuments: () => void;
  onViewCustomerUploadDocuments: () => void;
  onOpenBulkUploadModal: () => void;
};

export function ApplicantTabsHeaderActions({
  isXsOrSm,
  tabIndex,
  countBulkUpload,
  isAddingCoApplicant,
  enableCustomerJourney,
  partnerStartedJourney,
  showTitle = true,
  showActions = true,
  hideTriggerLink = false,
  documentsReadOnly = false,
  triggerOnly = false,
  primaryTriggerLink = false,
  onAddCoApplicant,
  onTriggerLinkToCustomer,
  onViewBulkDocuments,
  onViewCustomerUploadDocuments,
  onOpenBulkUploadModal,
}: Props) {
  if (!showTitle && !showActions) {
    return null;
  }
  if (triggerOnly && (partnerStartedJourney || documentsReadOnly)) {
    return null;
  }

  const TriggerLinkButton = primaryTriggerLink ? PrimaryButton : UploadButton;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: showTitle && showActions ? "space-between" : showActions ? "flex-end" : "flex-start",
        alignItems: "center",
        flexWrap: triggerOnly ? "nowrap" : "wrap",
        gap: 1,
        mb: triggerOnly ? 0 : 2,
      }}
    >
      {showTitle && (
        <Typography
          variant="h6"
          component="h2"
          sx={{ fontWeight: 600, fontSize: "16px", color: "#5d586c" }}
        >
          {isXsOrSm ? "Upload Documents" : "Documents"}
        </Typography>
      )}

      {showActions && (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: triggerOnly ? "nowrap" : "wrap",
            width: { xs: "100%", sm: "auto" },
          }}
        >
        {}
        {/* <UploadButton
          onClick={onAddCoApplicant}
          customHeight={"38px"}
          sx={{ mb: 1, width: isXsOrSm ? "100vw !important" : "auto" }}
          disabled={isAddingCoApplicant || enableCustomerJourney || partnerStartedJourney}
        >
          {isAddingCoApplicant ? (
            <>
              <CircularProgress
                size={16}
                sx={{ color: "rgba(0, 179, 181, 1)", marginRight: "5px" }}
              />{" "}
              Add Co-Applicant
            </>
          ) : (
            <>
              <img
                src={AddCoApplicantIcon}
                alt="Add"
                style={{ marginRight: "5px", width: "16px", height: "16px" }}
              />
              Add Co-Applicant
            </>
          )}
        </UploadButton> */}

        {!partnerStartedJourney && !documentsReadOnly && !hideTriggerLink && (
          <TriggerLinkButton
            onClick={onTriggerLinkToCustomer}
            {...(!primaryTriggerLink ? { customHeight: "38px" } : {})}
            sx={{ mb: triggerOnly ? 0 : 1, width: isXsOrSm ? "100vw !important" : "auto" }}
          >
            <img
              src={TriggerLinkIcon}
              alt="Trigger"
              style={{ marginRight: "5px", filter: primaryTriggerLink ? "brightness(0) invert(1)" : undefined }}
            />
            Trigger Link to Customer
          </TriggerLinkButton>
        )}

        {triggerOnly ? null : (
          <>

        <UploadButton
          // disabled={true}
          onClick={onViewBulkDocuments}
          customHeight={"38px"}
          sx={{ mb: 1, width: isXsOrSm ? "100vw !important" : "auto" }}
        >
          <img src={Eyecon} alt="View" style={{ marginRight: "5px" }} />
          View bulk documents

          {countBulkUpload > 0 && (
            <Box
              sx={{
                position: "absolute",
                top: "-8px",
                right: "-8px",
                backgroundColor: "#ff4444",
                color: "#fff",
                borderRadius: "50%",
                minWidth: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "12px",
                fontWeight: "600",
                padding: "2px",
              }}
            >
              {countBulkUpload > 99 ? "99+" : countBulkUpload}
            </Box>
          )}
        </UploadButton>

        {partnerStartedJourney && (
          <UploadButton
            onClick={onViewCustomerUploadDocuments}
            customHeight={"38px"}
            sx={{ mb: 1, width: isXsOrSm ? "100vw !important" : "auto" }}
          >
            <img src={Eyecon} alt="View" style={{ marginRight: "5px" }} />
            View Customer Upload Documents
          </UploadButton>
        )}
        {/* <PrimaryButton
              color="primary"
              sx={{ width: isXsOrSm ? "100vw" : "auto" }}
              onClick={async () => {
              try {
                const response = await eligibilityCheckServices.download("trackingId");
                if (response && response.data) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "bulk-documents.zip");
                document.body.appendChild(link);
                link.click();
                link.parentNode?.removeChild(link);
                }
              } catch (error) {
                // handle error if needed
                console.error("Download failed", error);
              }
              }}
            >
              Download Documents
            </PrimaryButton> */}
        {!documentsReadOnly && (
          <PrimaryButton
            type="button"
            onClick={onOpenBulkUploadModal}
            sx={{ width: isXsOrSm ? "100vw" : "auto" }}
          >
            <img
              src={UploadWhiteIcon}
              alt="Upload"
              style={{ marginRight: "5px" }}
            />
            Upload bulk documents
          </PrimaryButton>
        )}
          </>
        )}
        </Box>
      )}
    </Box>
  );
}
